import Axios from 'axios';
import {Credentials} from "@commons/mapping/Credentials";
import {LoginResultRecord} from "@commons/mapping/LoginResultRecord";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {fetchConfig} from "@commons/utils/fetchBaseFPNetQuery";
import {systemInfo} from "@commons/global";

/**
 *
 * @param url es. https://fpnet2.ericed.it/FPNet2021/access/login
 * @param params
 */
export function signIn(url: string, params: Credentials): Promise<LoginResultRecord> {

    //const api = `${url}?username=${params.userName}&password=${params.passwordInChiaro}`;
    const api = url;
    const {userName, passwordInChiaro, password} = params;
    return Axios.post<LoginResultRecord>(api, {
        userName, passwordInChiaro, password,
        platformType: fetchConfig.platformType?.toUpperCase(), // es. 'ios'
        isMobile: fetchConfig.isMobile,
        device: systemInfo.device, // es. iPhone 8 Plus
        app: systemInfo.appName, // es. FPNet-app
        release: systemInfo.appVersion, // es. 0.0.3
        osVersion: systemInfo.osVersion // es. 0.0.3
    })
        .then(res => {
            /*
                        if (params.rememberMe) {
                            setItemLocalStorage('token', res.data.token.token);
                        }
            */
            return res.data
        }, res => {
            console.log(res);
            throw res;
        })
}

/**
 *
 * @param url // https://fpnet2.ericed.it/FPNet2021/access/logout/a904e52ba796dbad9f86644eea36d018?auth_token=a904e52ba796dbad9f86644eea36d018&nowId=1661412947814
 * @param params
 */
export function signOut(url: string, token: string): Promise<void> {

    const api = `${url}/${token}`;

    return Axios.put<void>(api, {})
        .then(res => {
            //removeItemLocalStorage('token');
            return res.data;
        })
}

export function resetPassword(url: string, id: string): Promise<TokenRecord> {

    const api = `${url}?id=${id}`;

    return Axios.get<TokenRecord>(api, {})
        .then(res => {
            return res.data;
        }, res => {
            throw res;
        })
}